/**
 * This Object provides a set of common SELECTORS for components
 * which will be rendered client side and need a hook rendered by back-end.
 * Use this Object importing csr-anchors.js and calling component.CONSTANT.
 */

const components = Object.freeze({
  PARSELY_TOP_NEWS: '#parselyTopNews',
  COOKIE_BANNER: '#bannerprivacy',
  INFINITE_SCROLLING: '.infinite-scrolling',
});

export const PARSELY_TOP_NEWS = components.PARSELY_TOP_NEWS;
export const COOKIE_BANNER = components.COOKIE_BANNER;
export const INFINITE_SCROLLING = components.INFINITE_SCROLLING;
